export const ConfigData = [
  {
    id: "date",
    name: "Date",
    isShow: true,
    width: "100px",
    filter: true,
  },
  {
    id: "pickup",
    name: "Pick-Up Point",
    isShow: true,
    width: "180px",
    filter: true,
  },
  {
    id: "destination",
    name: "Destination",
    isShow: true,
    width: "180px",
    filter: true,
  },
  {
    id: "boarded",
    name: "Boarded",
    isShow: true,
    width: "120px",
    filter: true,
  },
  {
    id: "cancelled",
    name: "Cancelled",
    isShow: true,
    width: "120px",
    filter: true,
  },
  {
    id: "absence",
    name: "Absence",
    isShow: true,
    width: "120px",
    filter: true,
  },
  {
    id: "total",
    name: "Total",
    isShow: true,
    width: "120px",
    filter: true,
  },
  
];